var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS23(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 41,
    r: 19,
    fill: "#BB91F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6445 39.3555C20.8477 37.5586 22.0391 33.7891 21.1211 31.582C20.2031 29.375 16.6875 27.4414 16.6875 25C16.6875 22.5586 20.1641 20.7031 21.1211 18.418C22.0781 16.1328 20.8477 12.4414 22.6445 10.6445C24.4414 8.84766 28.2109 10.0391 30.418 9.12109C32.625 8.20313 34.5586 4.6875 37 4.6875C39.4414 4.6875 41.2969 8.16406 43.582 9.12109C45.8672 10.0781 49.5586 8.84766 51.3555 10.6445C53.1523 12.4414 51.9609 16.2109 52.8789 18.418C53.7969 20.625 57.3125 22.5586 57.3125 25C57.3125 27.4414 53.8359 29.2969 52.8789 31.582C51.9219 33.8672 53.1523 37.5586 51.3555 39.3555C49.5586 41.1523 45.7891 39.9609 43.582 40.8789C41.375 41.7969 39.4414 45.3125 37 45.3125C34.5586 45.3125 32.7031 41.8359 30.418 40.8789C28.1328 39.9219 24.4414 41.1523 22.6445 39.3555Z",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5938 20.3125L34.1289 31.25L28.4062 25.7812",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS23);
export default __webpack_public_path__ + "static/media/s2-3.9e58f5d7305ecf4bd407efda90032936.svg";
export { ForwardRef as ReactComponent };